import { useEffect, useState } from 'react'
import backendAPI from '../utils/backendAPI'
import { getMerchantCheckoutContext, cacheMerchantBusinessName } from '../utils/merchantContext'

/**
 * Resolves the current merchant's id + business name. Falls back to a
 * fresh GET /api/user-businesses/ call (and caches the result) when
 * they aren't yet in localStorage — e.g. a first visit to this
 * origin/session before Billing or Profile have populated them.
 */
export function useResolvedMerchantId(userInfo, adminMerchantId, adminBusinessName) {
	const cached = getMerchantCheckoutContext(userInfo)
	const [merchantId, setMerchantId] = useState(adminMerchantId || cached.merchantId)
	const [businessName, setBusinessName] = useState(adminBusinessName || cached.businessName)

	useEffect(() => {
		if (adminMerchantId || (cached.merchantId && cached.businessName)) {
			setMerchantId(adminMerchantId || cached.merchantId)
			setBusinessName(adminBusinessName || cached.businessName)
			return
		}
		let cancelled = false
		backendAPI
			.get('/api/user-businesses/')
			.then(({ data }) => {
				if (cancelled) return
				const row = Array.isArray(data) ? data[0] : null
				const id = String(row?.merchant_id || '').trim()
				const name = String(row?.business_name || row?.businessName || '').trim()
				if (id) {
					localStorage.setItem('merchant_id', id)
					localStorage.setItem('business_id', id)
					setMerchantId(id)
				}
				if (name) {
					cacheMerchantBusinessName(name)
					setBusinessName(name)
				}
			})
			.catch(() => {
				// ignore — resolution stays empty, caller shows its own error state
			})
		return () => {
			cancelled = true
		}
	}, [adminMerchantId, adminBusinessName, cached.merchantId, cached.businessName])

	return { merchantId, businessName }
}
